import {EntityModel} from "@fedeltapointofsale/data-client";
import {MemberData} from "./member.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class MemberEntityModel extends EntityModel<MemberData> {
    constructor(injector: Injector) {
        super(injector, MemberData);
    }

    override isEntityCloneable(): boolean {
        return false;
    }

    override async canUpdateEntity(): Promise<boolean> {
        return this.data.integratedLoyaltyId == undefined;
    }
}
